import React, { useState, useEffect } from 'react';
import './CorporationRow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function CorporationRow({ showDetail, corporation }) {
  const [key, setKey] = useState('val');
  if (logComponent('CorporationRow')) { console.debug('CorporationRow rendered'); }


  const getStatusIcon = () => {
    // For now, returning Active in all cases
    // In future this may return Active or Inactive
    // depending on the Corporation
    let iconToUse = 'active';

    switch(iconToUse) {
      case 'active':
        return (
          <div className="Corporation-Row__active">
            <FontAwesomeIcon 
              className="Corporation-Row__active-icon" 
              icon="check-circle" />
            <span className="Corporation-Row__status-text">Active</span>
          </div>);
      case 'inactive':
        return (
          <div className="Corporation-Row__inactive">
            <FontAwesomeIcon 
              className="Corporation-Row__inactive-icon" 
              icon="times-circle"/>
            <span className="Corporation-Row__status-text">Active</span>
          </div>);      
      default: 
        return null;
    }
  }

  const getStatusIconNoText = () => {
    // For now, returning Active in all cases
    // In future this may return Active or Inactive
    // depending on the Facility
    let iconToUse = 'active';

    switch(iconToUse) {
      case 'active':
        return (
            <FontAwesomeIcon 
              className="Corporation-Row__active-icon" 
              icon="check-circle" />
        );
      case 'inactive':
        return (
            <FontAwesomeIcon 
              className="Corporation-Row__inactive-icon" 
              icon="times-circle"/>
        );      
      default: 
        return null;
    }
  }

  const handleButtonClick = () => {
    showDetail(corporation);
  }


  return (
    <tr className="Corporation-Row">
    <td className="Corporation-Row__cell Corporation-Row__name-cell">
      <span className="Corporation-Row__name">{ corporation.name }</span>
      <span className="Corporation-Row__status-icon">{ getStatusIconNoText() }</span>
    </td>
    <td className="Corporation-Row__cell Corporation-Row__status-cell">{ getStatusIcon() }</td>
    <td className="Corporation-Row__cell Corporation-Row__detail-cell">
      <button 
        className="Corporation-Row__icon-btn"
        onClick={handleButtonClick}>
        <FontAwesomeIcon icon="ellipsis-h"></FontAwesomeIcon>
      </button>
    </td>
  </tr>
  );
}